var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustratn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 184.054,
    height: 155.417,
    viewBox: "0 0 184.054 155.417",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00bfa5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbfbfb"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6423",
    "data-name": "Group 6423",
    transform: "translate(-87 -46.852)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_11_1",
    "data-name": "Component 11 \\u2013 1",
    transform: "translate(87 46.852)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38925",
    "data-name": "Path 38925",
    d: "M119.862,106.487c17.675,0,44.23-65.726,34.219-80.629-3.317-4.938-19.335,4.654-24.973,9.852-5.122,4.721,0,5.118,0,0,0-.765,1.572.009,2.6-.61,5.48-3.322,23.836-5.078,22.378-9.241C147.213,6.242,75.856,0,52.55,0,23.528,0,0,22.013,0,49.168S90.839,106.487,119.862,106.487Z",
    transform: "translate(0 56.003) rotate(-21)",
    opacity: 0.1,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_38781",
    "data-name": "Path 38781",
    d: "M764.143,526.472c-3.728-2.5-6.405-6.937-5.789-11.382a20.678,20.678,0,0,0,12.679,6.386c1.87.211,3.972.252,5.285,1.6a4.622,4.622,0,0,1,1.156,3.226,13.724,13.724,0,0,1-.587,3.454l.065.285C772.47,529.817,767.872,528.97,764.143,526.472Z",
    transform: "translate(-625.647 -371.774)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38782",
    "data-name": "Path 38782",
    d: "M762.98,514.67a17.673,17.673,0,0,0,6.906,8.4,7.613,7.613,0,0,0,2.167.995,4.366,4.366,0,0,0,2.3-.059,9.034,9.034,0,0,1,2.13-.5,2.673,2.673,0,0,1,2.007.865,6.944,6.944,0,0,1,1.358,2.407,6.819,6.819,0,0,0,1.51,2.674c.093.087-.047.226-.14.14-1.34-1.245-1.464-3.217-2.511-4.656a2.707,2.707,0,0,0-2.039-1.232,7.01,7.01,0,0,0-2.172.464,4.657,4.657,0,0,1-2.243.141,7.036,7.036,0,0,1-2.2-.908,17.146,17.146,0,0,1-4.09-3.463,17.987,17.987,0,0,1-3.174-5.22c-.047-.118.145-.168.191-.05Z",
    transform: "translate(-630.179 -371.355)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38783",
    "data-name": "Path 38783",
    d: "M857.337,570.868a2.652,2.652,0,0,1-3.389.553c-.109-.066-.011-.238.1-.172a2.455,2.455,0,0,0,3.151-.521c.082-.1.221.043.14.14Z",
    transform: "translate(-718.674 -419.74)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38784",
    "data-name": "Path 38784",
    d: "M816.667,561.931a5.11,5.11,0,0,0-1.6-3.362c-.093-.087.047-.227.14-.14a5.316,5.316,0,0,1,1.66,3.5c.009.127-.189.127-.2,0Z",
    transform: "translate(-672.838 -409.135)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38785",
    "data-name": "Path 38785",
    d: "M877.395,532.841a1.5,1.5,0,0,0,.575-1.3c-.01-.127.188-.126.2,0a1.682,1.682,0,0,1-.633,1.443.1.1,0,0,1-.14,0A.1.1,0,0,1,877.395,532.841Z",
    transform: "translate(-742.709 -385.881)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38786",
    "data-name": "Path 38786",
    d: "M738.626,456.982c.009.079.017.158.028.238a19.756,19.756,0,0,0,.625,3.145c.021.08.044.161.068.24a20.839,20.839,0,0,0,3.5,6.829,20.236,20.236,0,0,0,2.063,2.28,13.172,13.172,0,0,1,2.848,3.175,3.458,3.458,0,0,1,.177.392l-3.292,6.534-.043.034-.12.267-.124-.1-.071-.06c-.016-.013-.031-.027-.046-.038l-.014-.013c-.015-.011-.028-.023-.041-.034q-.351-.3-.7-.606s0,0,0,0a29.753,29.753,0,0,1-4.745-5.194c-.04-.058-.082-.116-.12-.177a19.307,19.307,0,0,1-1.569-2.733,17.088,17.088,0,0,1-.65-1.6,14.2,14.2,0,0,1-.778-4.37,11.272,11.272,0,0,1,2.854-8.043C738.522,457.089,738.573,457.036,738.626,456.982Z",
    transform: "translate(-592.99 -321.65)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38787",
    "data-name": "Path 38787",
    d: "M755.794,456.531a17.674,17.674,0,0,0,.458,10.864,7.611,7.611,0,0,0,1.131,2.1,4.365,4.365,0,0,0,1.869,1.336,9.036,9.036,0,0,1,2,.885,2.673,2.673,0,0,1,1.082,1.9,6.945,6.945,0,0,1-.365,2.739,6.819,6.819,0,0,0-.4,3.044c.022.125-.174.153-.2.027-.32-1.8.768-3.45.8-5.229a2.707,2.707,0,0,0-.886-2.211,7.01,7.01,0,0,0-2.013-.937,4.658,4.658,0,0,1-1.876-1.238,7.036,7.036,0,0,1-1.208-2.048A17.147,17.147,0,0,1,755,462.535a17.987,17.987,0,0,1,.609-6.079c.034-.122.217-.046.183.075Z",
    transform: "translate(-610.083 -321.143)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38788",
    "data-name": "Path 38788",
    d: "M805.417,517.581a2.652,2.652,0,0,1-3.039-1.6c-.047-.118.134-.2.182-.079a2.455,2.455,0,0,0,2.83,1.481C805.513,517.357,805.54,517.553,805.417,517.581Z",
    transform: "translate(-659.729 -372.426)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38789",
    "data-name": "Path 38789",
    d: "M772.849,537.218a5.111,5.111,0,0,0,.745-3.649c-.022-.125.174-.153.2-.027a5.316,5.316,0,0,1-.783,3.8C772.937,537.444,772.779,537.324,772.849,537.218Z",
    transform: "translate(-624.04 -387.62)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38790",
    "data-name": "Path 38790",
    d: "M797.563,482.209a1.5,1.5,0,0,0,1.244-.694c.068-.108.226.012.158.119a1.682,1.682,0,0,1-1.374.771.1.1,0,0,1-.112-.084A.1.1,0,0,1,797.563,482.209Z",
    transform: "translate(-652.542 -342.777)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "undraw_Mobile_feed_re_72ta_1_",
    "data-name": "undraw_Mobile_feed_re_72ta (1)",
    transform: "translate(139 81.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38834",
    "data-name": "Path 38834",
    d: "M358.545,103.943h-.425V92.306a6.735,6.735,0,0,0-6.735-6.735H326.73a6.735,6.735,0,0,0-6.735,6.735v63.842a6.735,6.735,0,0,0,6.735,6.735h24.655a6.735,6.735,0,0,0,6.735-6.735V112.227h.425Z",
    transform: "translate(-308.948 -85.571)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38835",
    "data-name": "Path 38835",
    d: "M367.292,102.066h-3.218a2.39,2.39,0,0,1-2.212,3.292H347.737a2.39,2.39,0,0,1-2.212-3.292h-3.006a5.03,5.03,0,0,0-5.03,5.03v63.748a5.03,5.03,0,0,0,5.03,5.03h24.773a5.03,5.03,0,0,0,5.03-5.03h0V107.1a5.03,5.03,0,0,0-5.03-5.03Z",
    transform: "translate(-324.583 -100.314)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1090",
    "data-name": "Rectangle 1090",
    width: 14.405,
    height: 24.609,
    transform: "translate(15.874 13.624)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1091",
    "data-name": "Rectangle 1091",
    width: 11.973,
    height: 27.861,
    transform: "translate(32.754 40.16)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1092",
    "data-name": "Rectangle 1092",
    width: 12.004,
    height: 6.774,
    transform: "translate(32.766 13.624)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1093",
    "data-name": "Rectangle 1093",
    width: 12.004,
    height: 7.288,
    transform: "translate(32.766 22.284)",
    fill: "#008c74"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1094",
    "data-name": "Rectangle 1094",
    width: 12.004,
    height: 6.774,
    transform: "translate(32.766 31.459)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1095",
    "data-name": "Rectangle 1095",
    width: 14.405,
    height: 10.724,
    transform: "translate(15.892 40.16)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1096",
    "data-name": "Rectangle 1096",
    width: 14.405,
    height: 15.08,
    transform: "translate(15.892 52.964)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38836",
    "data-name": "Path 38836",
    d: "M727.836,318.922c0,2.342-2.165,1.988-4.837,1.988s-4.837.354-4.837-1.988,1.058-6.493,4.837-6.493C726.908,312.429,727.836,316.581,727.836,318.922Z",
    transform: "translate(-664.818 -288.33)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38837",
    "data-name": "Path 38837",
    d: "M634.06,327.115a1.333,1.333,0,0,0,.823,1.87l.244,4.729,1.982-1.459-.535-4.267a1.34,1.34,0,0,0-2.513-.873Z",
    transform: "translate(-589.526 -300.782)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38838",
    "data-name": "Path 38838",
    d: "M819.02,528.828a1.332,1.332,0,0,0-.582-1.959l.351-4.722-2.149,1.2,0,4.3a1.34,1.34,0,0,0,2.384,1.182Z",
    transform: "translate(-752.761 -475.769)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38839",
    "data-name": "Path 38839",
    d: "M530.564,660.725h1.625l.773-6.266h-2.4Z",
    transform: "translate(-474.202 -584.936)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38840",
    "data-name": "Path 38840",
    d: "M742.666,794.022h3.2a2.039,2.039,0,0,1,2.039,2.039v.066h-5.238Z",
    transform: "translate(-686.718 -718.763)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38841",
    "data-name": "Path 38841",
    d: "M627.86,660.725h1.625l.773-6.266h-2.4Z",
    transform: "translate(-561.162 -584.936)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38842",
    "data-name": "Path 38842",
    d: "M839.961,794.022h3.2a2.039,2.039,0,0,1,2.039,2.039v.066h-5.238Z",
    transform: "translate(-773.677 -718.763)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38843",
    "data-name": "Path 38843",
    d: "M806,424.682l-.071-.013c-.592-.107-1.191-.215-1.717-.329l-.052-.011v-.053c-.009-2.4-.018-4.8-.031-7.227a15.275,15.275,0,0,1-1.527-8.188l0-.03.024-.017a1.571,1.571,0,0,1,1.583-.122,1.755,1.755,0,0,1,.9,1.332c.479,2.61.975,5.312,1.527,7.976l0,.01v.01c-.2,2.172-.417,4.418-.634,6.591Z",
    transform: "translate(-740.227 -374.225)",
    fill: "#008c74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38844",
    "data-name": "Path 38844",
    d: "M729.235,519.879l-.013-.061c-.76-3.595-1.494-6.522-2.2-9.353-.85-3.393-1.656-6.608-2.469-10.768.112,5.246.371,9.016.669,13.348.135,1.956.274,3.979.415,6.341l0,.072-.072,0c-2.543-.065-5.147-.222-7.667-.374l-.067,0,0-.067c.477-7.03.626-11.6.736-14.934.23-7.037.266-8.119,2.887-14.075a1.519,1.519,0,0,1,1.344-.792l5.158.8.009.045c.146.733.868,2.958,1.867,6.036,2.137,6.582,5.366,16.528,6.375,22.457l.011.067-.067.01c-1.465.208-2.52.425-3.54.635-.965.2-1.963.4-3.321.606Z",
    transform: "translate(-664.523 -446.323)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38845",
    "data-name": "Path 38845",
    d: "M724.845,407.3a5.382,5.382,0,0,1-3.713-1.408,1.1,1.1,0,0,1-.543-.856,1.116,1.116,0,0,1,.262-.906c-.956-1.158-1.944-2.354-2.889-3.572l-.026-.034.03-.058c.618-1.181,1.258-2.4,1.872-3.61a.631.631,0,0,1,.514-.389.733.733,0,0,1,.566.127v-.029c.026-.611.051-1.222.078-1.8l0-.062h.062c1.181-.026,2.4-.053,3.6-.124l.046,0,.595,1.327a4.865,4.865,0,0,1,2.791.566l.039.021,0,.044a27.013,27.013,0,0,0,.155,6.849,14,14,0,0,1-.249,2.936l-.006.025-.021.014A5.658,5.658,0,0,1,724.845,407.3Z",
    transform: "translate(-664.615 -361.747)",
    fill: "#008c74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38846",
    "data-name": "Path 38846",
    d: "M651.436,373.749l-.079-.036c-.925-.464-1.853-.979-2.75-1.477l-.124-.024a15.621,15.621,0,0,1-5.8-1.985l-.016-.01-.009-.017a10.573,10.573,0,0,1-1.1-6.575l.005-.055.055,0c.231-.019.608-.031.972-.043s.721-.024.945-.042l.052,0,.016.05c.279.862.517,1.667.768,2.519.258.876.525,1.781.85,2.786a20.417,20.417,0,0,0,5.373.1,1.775,1.775,0,0,1,1.55.7l.018.023,0,.029c-.218,1.333-.469,2.674-.712,3.97Z",
    transform: "translate(-596.274 -333.954)",
    fill: "#008c74"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_689",
    "data-name": "Ellipse 689",
    cx: 3.255,
    cy: 3.255,
    r: 3.255,
    transform: "translate(53.705 30.491) rotate(-61.337)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38847",
    "data-name": "Path 38847",
    d: "M728.142,329.6h1.287l.568-1.59.114,1.59h.615l.331-.928.066.928h4.572a3.445,3.445,0,0,0-3.445-3.445h-.663a3.445,3.445,0,0,0-3.445,3.445Z",
    transform: "translate(-673.737 -300.593)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38848",
    "data-name": "Path 38848",
    d: "M297.479,812.641H216.106a.106.106,0,0,1,0-.213h81.372a.106.106,0,0,1,0,.213Z",
    transform: "translate(-216 -735.214)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_38826",
    "data-name": "Path 38826",
    d: "M363.84,453.807a1.936,1.936,0,1,1,1.936-1.936A1.936,1.936,0,0,1,363.84,453.807Z",
    transform: "translate(-217.648 -335.81)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38827",
    "data-name": "Path 38827",
    d: "M423.883,261.239a2.136,2.136,0,1,1,2.136-2.136A2.136,2.136,0,0,1,423.883,261.239Z",
    transform: "translate(-266.807 -171.67)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38828",
    "data-name": "Path 38828",
    d: "M807.714,370.654a1.837,1.837,0,1,1,1.837-1.837,1.837,1.837,0,0,1-1.837,1.837Z",
    transform: "translate(-592.592 -267.817)",
    fill: "#f0f0f0"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustratn);
export default __webpack_public_path__ + "static/media/Illustratn.d2a4f60199130d74a7a7ac66c29a43c1.svg";
export { ForwardRef as ReactComponent };